import { useEffect, useRef, useState } from 'react';
import { useOnScreen } from './useOnScreen';

export const useLazyMapRender = () => {
  const mapBlockRef = useRef<HTMLDivElement | null>(null);
  const isMapVisible = useOnScreen(mapBlockRef, 600);
  const [mapWasVisible, setMapWasVisible] = useState(false);

  useEffect(() => {
    if (isMapVisible && !mapWasVisible) setMapWasVisible(true);
  }, [isMapVisible, mapWasVisible]);

  return { mapBlockRef, isMapVisible: isMapVisible || mapWasVisible };
};
